import {createStore} from 'ice';
import user from '@/models/user';

export default createStore({
    user,
});
